import { useState } from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';

import CustomScreen from './CustomScreen';
import SelectionScreen from './SelectionScreen';

export default function TipInputModal({
  isOpen,
  toggleModal,
  defaultTips,
  onSelectTip,
  onSetCustomTip,
}) {
  const [screen, setScreen] = useState('selection');

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={() => toggleModal(false)}
      className="customer-tip-modal"
    >
      {screen === 'selection' ? (
        <SelectionScreen
          defaultTips={defaultTips}
          onSelectTip={onSelectTip}
          toggleModal={toggleModal}
          setScreen={setScreen}
        />
      ) : (
        <CustomScreen
          setScreen={setScreen}
          onSetCustomTip={onSetCustomTip}
          toggleModal={toggleModal}
        />
      )}
    </ReactModal>
  );
}
